<template>
	<v-spinner :size="20" color="--blue-grey-200" />
</template>

<script>
export default {
	name: 'VExtInputLoading'
};
</script>
